import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { Box, CircularProgress, } from "@mui/material";
import { Button, Radio, TextField, Typography } from "@material-ui/core";

import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AddShoppingCart, WatchOutlined, WatchRounded, AccessTime, CalendarToday, CalendarTodayTwoTone } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import { addDays } from "../../utils/addDays.js";
import { NotificationManager } from "react-notifications";
import AdditionalInfoScreenNew from "./AdditionalInfoScreenNew.jsx";
import Dropzone from "react-dropzone";
import { getCookies } from "../../utils/getToken.js";
import BookingConfirmAlert from "../../components/Alert/BookingConfirmAlert.jsx";
import TermsOfUseAlert from "../../components/Alert/TermsOfUseAlert.jsx";
import CancellationPolicyAlert from "../../components/Alert/CancellationPolicyAlert.jsx";
import Axios from "axios";
import { roundUpTransaction } from "../../utils/roundUpTransaction.js";

import { Dna, Vortex } from 'react-loader-spinner'
import "./index.css"
import { cardList } from "../../apiHelpers/booking/list.js";
import HOCLoader from "../../components/HOC/HOCLoader.jsx";
import BookingSuccessScreenNew from "./BookingSuccessScreenNew.jsx";
import { event } from "jquery";
import moment from "moment";
import "./Calender.css"
import NavBarNewForConfirmPage from "../../components/NavBarNew/NavBarNewForConfirmPage.js";
const disableDates = new Date();
const date1 = disableDates.getDate();


const AdditionImagePicker = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                        <div style={{
                            // position: "absolute", 
                            // top: "207px", 
                            // left: "210px" 
                        }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {/* <img src={uploadIcon} style={{ height: "25px" }} /> */}
                                        <Box > <Add style={{ fontSize: 30 }} /></Box>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}


/************************************* This code is completely messed up   *******************************************************/
/************************************* May god bless you my dear developer *******************************************************/
/************************************* This is a biggest peace of dog shit  ******************************************************/

class ConfirmBookingScreenNewLayout extends Component {

    constructor(props) {
        super(props);
        console.log("All Data", props)

        this.state = {

            value: 0,
            futureValue: 0,
            selectedValue: null,

            // if coming from successfull login with guest login then booking data
            booking_data: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.booking_data : this.props.history.location.state.booking_data,
            taskDatanewData: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.taskDataFututre : (this.props.history.location.state.taskDataFututre || this.props.history.location.state.taskDataFromConfirmPage),
            bookingPath: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.booking_data.BookingPath : this.props.history.location.state.BookingPath,
            bookingDateEdit: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.booking_data.bookingDateEdit : this.props.history.location.state.bookingDateEdit,
            bookingSlotEdit: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.booking_data.bookingSlotEdit : this.props.history.location.state.bookingSlotEdit,
            originalCalendarDate: '',
            taskDetailsPrev: this.props.history.location.loginPath === "BookingConfirmPaymentLogin" ? this.props.history.location.state.taskData : this.props.history.location.state.taskData,
            whichServiceType: 1,
            todayServiceActive: false,
            futureServiceActive: true,
            todayTimeSlots: [{ "end": 32399, "label": "06am - 09am", "start": 21600, "status": true }, { "end": 43199, "label": "09am - 12pm", "start": 32400, "status": true }, { "end": 53999, "label": "12pm - 03pm", "start": 43200, "status": true }, { "end": 64799, "label": "03pm - 06pm", "start": 54000, "status": true }, { "end": 75599, "label": "06pm - 09pm", "start": 64800, "status": true }],
            futureTimeSlots: [{ "end": 32399, "label": "06am - 09am", "start": 21600, "status": true }, { "end": 43199, "label": "09am - 12pm", "start": 32400, "status": true }, { "end": 53999, "label": "12pm - 03pm", "start": 43200, "status": true }, { "end": 64799, "label": "03pm - 06pm", "start": 54000, "status": true }, { "end": 75599, "label": "06pm - 09pm", "start": 64800, "status": true }],
            selectDateError: false,
            selectFutureDateError: false,
            selectCardError: false,
            selectAddressError: false,
            isTimeslotSelected: this.props.history.location.state.booking_data == undefined ? false : this.props.history.location.state.booking_data.booking_slot_state,
            selectedTimeSlotLabel: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.booking_slot,
            timeNew: '',
            todaysDate: addDays(new Date, 1),
            bookingFinalPrice: this.props.history.location.state.taskData.price,
            selectTimeslotError: (this.props.history.location.state.BookingPath === 'edit' || this.props.history.location.state.BookingPath === 'TimeSlotSelectedState') ? false : true,

            // aditional info states
            home_aval: this.props.history.location.state.booking_data == undefined ? 1 : this.props.history.location.state.booking_data.home_stay,
            home_instruction: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.instructions,
            home_stay: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.home_instruction,
            img_url_1: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.booking_img1,
            img_url_2: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.booking_img2,
            img_url_3: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.booking_img3,
            img_url_4: this.props.history.location.state.booking_data == undefined ? '' : this.props.history.location.state.booking_data.booking_img4,
            profileImagebase64Data1: null,
            profileImagebase64Data2: null,
            profileImagebase64Data3: null,
            profileImagebase64Data4: null,

            // confirm booking states
            update: false,
            showAlert: false,
            showTermOfUseAlert: false,
            booking_agree: 0,
            bookingDetailsConfirmPrev: this.props.history.location.state.bookingDetails,
            bookingInfoDataPrev: this.props.history.location.state.bookingInfoData,
            addressData: [],
            addressId: '',
            cardListNew: [],
            ref_flag: false,
            booking_discount: 0,
            refer_code: '',
            bookingAgreeError: false,
            booking_total: '',
            loading: false,
            authBookingData: this.props.history.location.state,
        };
        this.handleImage1Drop = this.handleImage1Drop.bind(this)
        this.handleImage2Drop = this.handleImage2Drop.bind(this)
        this.handleImage3Drop = this.handleImage3Drop.bind(this)
        this.handleImage4Drop = this.handleImage4Drop.bind(this)
    }
    componentDidMount() {
        console.log("taskDetailsPrev new LAYOUT", this.state.taskDetailsPrev);
        console.log('carddddddddddddddddddddddddddd', this.state.cardListNew)
        this.getAddressData();
        this.getCardList();
        this.CheckReferal();

        if (this.state.bookingPath == 'edit') {
            this.origialTimeslotForEdit()
        }
    }

    getAddressData() {
        this.props.getAddressListAction(this.onGetAddressDone);
    }

    getCardList() {
        this.props.cardListAction(this.onCardlistDone);
    }


    CheckReferal = async () => {
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        console.log(">>>>>>>>>>>>>this.props.userData", this.props.userData);
        this.setState({
            showAlert: false
        })
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/refer/check`,
                data: {
                    refer_code: this.props.userData.referral_code,
                    refer_phone: this.props.userData.phone
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('REFERRAL DATA', data.data.booking_discount);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    ref_flag: true,
                    booking_discount: data.data.booking_discount
                })
            }
            else {
                this.setState({
                    loading: false,
                    ref_flag: false,
                    booking_discount: 0
                })
            }
        } catch (error) {
            console.log("=========================REBOOK ERRORRRRRR", error);
        }
    }

    onGetAddressDone = (success, data) => {
        if (success) {
            this.setState({
                addressData: data.detail.addresses[0],
                refer_code: data.detail.referral_code,
            });
        }
        console.log("ADDRESSS NEWWWWWW", this.state.addressData);
    };


    onCardlistDone = (success, data) => {
        if (success) {
            this.setState({ cardListNew: [data.sources.data[0]] });
        }
        console.log("CARDDDDDDSSS NEWWWWWW", data.sources);
    };

    handleRadioChangeForBooking = event => {
        this.setState({ booking_agree: event.target.value, bookingAgreeError: false })
    };

    origialTimeslotForEdit() {
        let objIndex = this.state.futureTimeSlots.findIndex((obj => obj.label === this.state.bookingSlotEdit));
        console.log('objIndex', objIndex);
        this.setState({
            isTimeslotSelected: this.state.futureTimeSlots[objIndex].label
        })

    }

    addInstruction = (e) => {
        this.setState({
            home_instruction: e.target.value
        })
        this.props.setHomeInstructionAction(this.state.home_instruction);
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    handleEventClick = (singleEvent) => {
        console.log("Event date");
        console.log(singleEvent);
        //     this.props.history.push({
        //       pathname: `/user/booking/detail/${singleEvent.id}`,
        //       bookingId: singleEvent.id,
        //     });
    };

    handleSelect = (event) => {
        console.log("CLICK EVENT ", event);
    };

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    minusDays(date, days) {
        var minusResult = new Date(date);
        minusResult.setDate(minusResult.getDate() - days);
        return minusResult;
    }

    updatingTodaysTiminggggg = () => {
        const now = new Date();
        let timeNewwHrs;
        const month = now.getMonth();
        if (month < 2 || month > 10) {
            // It's outside of DST.
            timeNewwHrs = showDate(8);
            console.log("Pacific Time is currently in standard time (UTC-8).");
        } else if (month > 2 && month < 10) {
            // It's during DST.
            timeNewwHrs = showDate(7);
            console.log("Pacific Time is currently in daylight saving time (UTC-7).");
        } else {
            const previousSunday = now.getDate() - now.getDay();
            const transitionStart = new Date(now.getFullYear(), 2, previousSunday, 2, 0, 0);
            const transitionEnd = new Date(now.getFullYear(), 10, previousSunday, 2, 0, 0);

            if (now >= transitionStart && now < transitionEnd) {
                console.log("Pacific Time is currently in daylight saving time (UTC-7).");
                timeNewwHrs = showDate(7);
            } else {
                console.log("Pacific Time is currently in standard time (UTC-8).");
                timeNewwHrs = showDate(8);
            }
        }

        function showDate(time) {
            const now = new Date();
            const utcMinus7 = now.getTime() - (time * 60 * 60 * 1000);
            const date = new Date(utcMinus7).toISOString().split('T')[0];
            const [hours, minutes, seconds] = new Date(utcMinus7).toISOString().split('T')[1].slice(0, -5).split(':');
            return Number(hours)
        }

        if (timeNewwHrs < 6) {
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = true;
            newTimeSlots[1].status = true;
            newTimeSlots[2].status = true;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
        } else if (timeNewwHrs >= 6 && timeNewwHrs < 9) {
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = true;
            newTimeSlots[2].status = true;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
        } else if (timeNewwHrs >= 9 && timeNewwHrs < 12) {
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = true;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
        } else if (timeNewwHrs >= 12 && timeNewwHrs < 15) {
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = false;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
        } else if (timeNewwHrs >= 15 && timeNewwHrs < 18) {
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = false;
            newTimeSlots[3].status = false;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
        } else if (timeNewwHrs >= 18) {
            // const newTimeSlots = [...this.state.todayTimeSlots];
            // newTimeSlots[0].status = false;
            // newTimeSlots[1].status = false;
            // newTimeSlots[2].status = false;
            // newTimeSlots[3].status = false;
            // newTimeSlots[4].status = false;
            // this.setState({ todayTimeSlots: newTimeSlots });
            this.setState({
                selectFutureDateError: true
            })
        }
    }



    handleServiceType = (type) => {
        console.log("type", type);
        this.setState({
            whichServiceType: type
        })
        if (type === 0) {
            this.updatingTodaysTiminggggg();

            this.setState({
                todaysDate: new Date(),
                todayServiceActive: true,
                futureServiceActive: false,
                bookingFinalPrice: this.state.taskDetailsPrev.rush_hr_price
            })
        } else if (type === 1) {
            this.setState({
                todaysDate: addDays(new Date, 1),
                todayServiceActive: false,
                futureServiceActive: true,
                bookingFinalPrice: this.state.taskDetailsPrev.price
            })
        }
    }

    renderFutureTimeslots = () => {
        return (
            <div style={{
                // padding: 20,
                width: '100%',
                height: '190px',
                marginTop: 15
            }}>
                {/* <p>Future slots</p> */}
                {
                    this.state.selectDateError
                        ?
                        <div>
                            <p>Please select a future date</p>
                        </div>
                        :
                        <div>
                            <p style={{ color: 'red', }}>{this.state.selectTimeslotError ? 'Please Select a Timeslot' : ''}</p>

                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: "pointer"
                                // paddingTop: 20
                            }}>
                                {this.state.futureTimeSlots.length > 0 &&
                                    this.state.futureTimeSlots.map((timeSlot, index) => {

                                        return (
                                            <div
                                                key={index}
                                                disabled={!timeSlot.status}
                                                onClick={() =>
                                                    timeSlot.status && this.onTimeSlotSelected(timeSlot)
                                                }
                                                style={{
                                                    backgroundColor:
                                                        this.state.time === timeSlot.start ||
                                                            this.state.isTimeslotSelected === timeSlot.label
                                                            ? '#0078ff'
                                                            : !timeSlot.status
                                                                ? 'grey'
                                                                : '#fff',
                                                    margin: 5,
                                                    borderRadius: 35,
                                                    border: '1px solid #0078ff',
                                                    opacity: timeSlot.status ? 1 : 0.5,
                                                }}

                                            >
                                                <p
                                                    style={{
                                                        color: this.state.time === timeSlot.start ||
                                                            this.state.isTimeslotSelected === timeSlot.label
                                                            ? '#fff'
                                                            : '#0078ff',

                                                        padding: 5,
                                                        marginBottom: 0
                                                    }}
                                                >
                                                    {timeSlot.label}
                                                </p>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                }
            </div>
        )
    }

    handleAddClick = () => {
        this.setState({ value: 2, futureValue: 1 });
        this.props.history.push('/user/profile/', {
            value: 2,
            loginPath: 'BookingConfirmPaymentLogin',
            booking_data: {
                booking_slot: this.state.selectedTimeSlotLabel,
                booking_slot_state: this.state.isTimeslotSelected,
                booking_date: this.state.todaysDate,
                home_instruction: this.state.home_stay,
                instructions: this.state.home_instruction,
                home_stay: this.state.home_aval,
                refer_code: this.state.refer_code,
                ref_flag: this.state.ref_flag,
                booking_img1: this.state.img_url_1,
                booking_img2: this.state.img_url_2,
                booking_img3: this.state.img_url_3,
                booking_img4: this.state.img_url_4
            },
            taskData: this.state.taskDetailsPrev,
            taskDataFromConfirmPage: this.state.taskDatanewData,
            futureValue: 1,
            BookingPath: "TimeSlotSelectedState"
        })
    }



    handleChange = (event, value) => {
        this.setState({ value })
    }

    renderTodayTimeslots = () => {
        return (
            <div style={{
                // padding: 20,
                width: '100%',
                height: '190px',
                marginTop: 15
            }}>
                {/* <p>Today slots</p> */}
                {
                    this.state.selectFutureDateError
                        ?
                        <div>
                            <p>Please select a date in the future</p>
                        </div>
                        :
                        <div>
                            <p style={{ color: 'red', }}>{this.state.selectTimeslotError ? 'Please Select a Timeslot' : ''}</p>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: "pointer"
                                // paddingTop: 20
                            }}>
                                {this.state.todayTimeSlots.length > 0 &&
                                    this.state.todayTimeSlots.map((timeSlot, index) => {

                                        return (
                                            <div
                                                key={index}
                                                disabled={!timeSlot.status}
                                                onClick={() =>
                                                    timeSlot.status && this.onTimeSlotSelected(timeSlot)
                                                }
                                                style={{
                                                    backgroundColor:
                                                        this.state.time === timeSlot.start ||
                                                            this.state.isTimeslotSelected === timeSlot.label
                                                            ? '#0078ff'
                                                            : !timeSlot.status
                                                                ? '#bbb'
                                                                : '#fff',
                                                    margin: 5,
                                                    borderRadius: 35,
                                                    border: '1px solid #0078ff',
                                                    opacity: timeSlot.status ? 1 : 0.5,
                                                }}
                                                className="time-selector"
                                            >
                                                <p
                                                    style={{
                                                        color: this.state.time === timeSlot.start ||
                                                            this.state.isTimeslotSelected === timeSlot.label
                                                            ? '#fff'
                                                            : '#0078ff',

                                                        padding: 5,
                                                        // paddingBottom: 0
                                                        marginBottom: 0
                                                    }}
                                                >
                                                    {timeSlot.label}
                                                </p>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                }

            </div>
        )
    }

    onTimeSlotSelected = (time) => {
        console.log("time selected", time);
        this.setState({
            selectTimeslotError: false,
            isTimeslotSelected: time.label,
            selectedTimeSlotLabel: time.label,
            timeNew: time.start,
        })
    }

    onDateSelected = (date) => {
        console.log("DATE NEEW CLICKED VAL", date)
        let abDate = new Date().getDate()
        let abMonth = new Date().getMonth()
        let abYear = new Date().getFullYear()
        let abAll = `${abDate}/${abMonth}/${abYear}`

        let cdDate = new Date(date).getDate()
        let cdMonth = new Date(date).getMonth()
        let cdYear = new Date(date).getFullYear()
        let cdAll = `${cdDate}/${cdMonth}/${cdYear}`
        if (abAll == cdAll) {
            this.setState({
                whichServiceType: 0
            })
        } else if (abAll !== cdAll) {
            this.setState({
                whichServiceType: 1,
                selectFutureDateError: false
            })
        }
        // const event = new Date(date);
        let event;
        if (this.state.bookingPath == 'edit') {
            event = new Date(this.state.bookingDateEdit)
        } else {
            event = new Date(date);
        }
        console.log("eevenntt", event);

        let formattedDate = event.toLocaleString().split(',')[0];
        console.log("formattedDate", formattedDate);
        this.setState({
            // todaysDate: formattedDate,
            todaysDate: date,
            selectDateError: false,
            originalCalendarDate: date
        }, () => { console.log('date.....', this.state.todaysDate) })
    }

    handleBookNow = async () => {
        var authToken = await getCookies();

        console.log("ppppppppppppppppppp", this.state.selectTimeslotError)
        this.state.booking_agree === 0
            ? this.setState({ bookingAgreeError: true })
            : this.state.selectFutureDateError
                ? NotificationManager.warning('Please select a Future date', '')
                : this.state.selectTimeslotError
                    ? NotificationManager.warning('Please select a Timeslot', '')
                    : authToken === 'Guest' || authToken === null
                        ? this.props.history.push('/user/signin',
                            {
                                booking_data: {
                                    booking_slot: this.state.selectedTimeSlotLabel,
                                    booking_slot_state: this.state.isTimeslotSelected,
                                    booking_date: this.state.todaysDate,
                                    home_instruction: this.state.home_stay,
                                    instructions: this.state.home_instruction,
                                    home_stay: this.state.home_aval,
                                    refer_code: this.state.refer_code,
                                    ref_flag: this.state.ref_flag,
                                    booking_img1: this.state.img_url_1,
                                    booking_img2: this.state.img_url_2,
                                    booking_img3: this.state.img_url_3,
                                    booking_img4: this.state.img_url_4
                                },
                                taskData: this.state.taskDetailsPrev,
                                loginPath: 'BookingConfirm',
                                booking_msg: "testing",
                                taskDataFromConfirmPage: this.state.taskDatanewData,
                                BookingPath: "TimeSlotSelectedState"
                            })
                        : this.state.selectCardError || this.state.cardListNew.length == 0
                            ? NotificationManager.warning('Please add a card')
                            : this.state.selectAddressError || this.state.addressData.length == 0
                                ? NotificationManager.warning('Please add Adress data')
                                : this.setState({ showAlert: true, loading: true })
    }


    handleCancelNow = () => {
        this.props.history.push('/');
    }



    handleRadioChange = event => {
        this.setState({ home_aval: event.target.value });

        //    this.setState({color: '#0078ff'});
        console.log("yoyo", event.target.value)
    };

    _handleReaderLoaded1 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data1: btoa(binaryString)
        });
    };
    _handleReaderLoaded2 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data2: btoa(binaryString)
        });
    };
    _handleReaderLoaded3 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data3: btoa(binaryString)
        });
    };
    _handleReaderLoaded4 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data4: btoa(binaryString)
        });
    };

    handleImage1Drop(files) {
        console.warn("CHOOSING FILE SHR", files)
        const maxSize = 10 * 1024 * 1024;
        const file = files[0]
        if (file && file.size <= maxSize) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(file);
        }
        else {
            alert("Image size is too large. Please choose an image smaller than 10MB.");
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img1");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone
        )
    }

    handleImage2Drop(files) {
        console.warn("CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img2");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone2
        )
    }

    handleImage3Drop(files) {
        console.warn("CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded3.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img3");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone3
        )
    }

    handleImage4Drop(files) {
        console.warn("CHOOSING FILE SHR", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded4.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img4");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone4
        )
    }

    onAdditionalImgDone = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_1: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone2 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_2: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone3 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_3: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone4 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_4: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleImage1DropRejected = (...args) => console.log('reject', args);

    onContinuePressed = () => {
        console.log("----------isTimeslotSelected", this.state.isTimeslotSelected);
        let booking_infoData = {
            booking_value: this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice,
            booking_date: this.state.todaysDate,
            booking_slot: this.state.selectedTimeSlotLabel,
            booking_quantity: this.state.taskDetailsPrev.quantity,
            task_id: this.state.taskDetailsPrev.key,
            service_id: this.state.taskDetailsPrev.category_id,
            category_id: this.state.taskDetailsPrev.mastercategory_id,
            booking_type: this.state.taskDetailsPrev.booking_type,
            service_type: this.state.taskDetailsPrev.service_type,
            task_name: this.state.taskDetailsPrev.full_name.service,
            service_name: this.state.taskDetailsPrev.full_name.category,
            category_name: this.state.taskDetailsPrev.full_name.master_category,
            originalCalendarDate: this.state.originalCalendarDate
        };
        this.props.history.push('/user/additional_info', { taskBooking: this.state.taskDetailsPrev, bookingInfoData: booking_infoData })
    }

    onBookNowStart = async () => {
        const orgDate = this.state.todaysDate
        let newdate = moment(orgDate).format("YYYY-MM-DD");
        console.log('aaaaaaaaaaaaaaaa', newdate)

        var authToken = await getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
            showAlert: false,
            // loading: true
        })

        console.log("BOOKING START DATA", {
            data: {
                task_id: this.state.taskDetailsPrev.key,
                service_id: this.state.taskDetailsPrev.category_id,
                category_id: this.state.taskDetailsPrev.mastercategory_id,
                booking_value: this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice,
                booking_quantity: this.state.taskDetailsPrev.quantity,
                booking_slot: this.state.selectedTimeSlotLabel,
                // booking_date: this.state.todaysDate,
                booking_date: newdate,
                home_instruction: this.state.home_stay,
                instructions: this.state.home_instruction,
                home_stay: this.state.home_aval,
                address_line1: this.state.addressData.address_line1,
                city: this.state.addressData.city,
                state: this.state.addressData.state,
                country: this.state.addressData.country,
                refer_code: this.state.refer_code,
                pay_amount: (this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice) - this.state.booking_discount,
                ref_flag: this.state.ref_flag,
                booking_img1: this.state.img_url_1,
                booking_img2: this.state.img_url_2,
                booking_img3: this.state.img_url_3,
                booking_img4: this.state.img_url_4
            }
        });

        try {
            this.setState({
                loading: true
            })
            const { data } = await Axios({
                method: 'post', //you can set what request you want to be
                url: `${SERVER_URL}/booking/confirm`,
                data: {
                    task_id: this.state.taskDetailsPrev.key,
                    service_id: this.state.taskDetailsPrev.category_id,
                    category_id: this.state.taskDetailsPrev.mastercategory_id,
                    booking_value: this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice,
                    booking_quantity: this.state.taskDetailsPrev.quantity,
                    booking_slot: this.state.selectedTimeSlotLabel,
                    // booking_date: this.state.todaysDate,
                    booking_date: newdate,
                    home_instruction: this.state.home_stay,
                    instructions: this.state.home_instruction,
                    home_stay: this.state.home_aval,
                    address_line1: this.state.addressData.address_line1,
                    city: this.state.addressData.city,
                    state: this.state.addressData.state,
                    country: this.state.addressData.country,
                    refer_code: this.state.refer_code,
                    pay_amount: (this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice) - this.state.booking_discount,
                    // pay_amount: this.state.booking_total,
                    ref_flag: this.state.ref_flag,
                    booking_img1: this.state.img_url_1,
                    booking_img2: this.state.img_url_2,
                    booking_img3: this.state.img_url_3,
                    booking_img4: this.state.img_url_4
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('BOOKINGG DATA new layout', data);
            if (data.status == 'OK') {
                NotificationManager.success(data.message, 'Success');
                this.props.history.push('/user/booking_success', { bookingSuccessData: data, loading: this.state.loading })
            }
            else {
                NotificationManager.error(data.message, 'Error');
                this.props.history.push('/user/dashboard')
            }
        } catch (error) {
            console.log("BOOKING ERRORRRRRR", error);
        } finally {
            this.setState({
                loading: false
            })
        }
    };




    render() {

        var authToken = getCookies();
        console.log("Token", authToken);
        const { loading } = this.state;
        console.log('card data .............', this.state.cardListNew);
        console.log('Adress data', this.state.addressData);
        console.log('referr_amount', this.state.booking_discount);
        console.log("state data", this.state)
        var well = {
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        var card = {
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 10,
            // marginRight: 20,
            padding: 10,
            // width: '30%'
        }
        var cardHeading = {
            backgroundColor: '#0078ff',
            color: 'white',
            fontWeight: '600',
            padding: '5px 20px',
            borderRadius: 50,
            fontSize: 18,
            marginBottom: 25
        }
        var infoHead = {
            color: 'green',
            fontSize: 18,
            fontWeight: '700',
            marginBottom: 20
        }

        const orgDate = this.state.taskDetailsPrev.booking_date
        const event = new Date(orgDate);
        let splittedDate = event.toLocaleString().split(',')[0];

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        let originalDate = splittedDate;
        // console.log('originalDate', originalDate);
        let year = originalDate.substring(6, 10)
        let month = (Number(originalDate.substring(3, 5)) - 1);
        let date = originalDate.substring(0, 2)

        let formattedDate = monthNames[month] + ' ' + date + ', ' + year;
        // console.log('formattedDate NEW', formattedDate);
        return (
            <div className="tz-2-com tz-2-main h4-padding" style={{
                // height: '107vh',
                // overflowY: 'scroll'
            }}>
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavBarNewForConfirmPage
                                title='Confirm Booking'
                                onClick={() => {
                                    this.props.history.push('/user/tasks', {
                                        booking_data: {
                                            booking_slot_state: this.state.isTimeslotSelected,
                                            booking_slot: this.state.selectedTimeSlotLabel,
                                            booking_date: this.state.todaysDate,
                                            home_instruction: this.state.home_stay,
                                            instructions: this.state.home_instruction,
                                            home_stay: this.state.home_aval,
                                            refer_code: this.state.refer_code,
                                            ref_flag: this.state.ref_flag,
                                            booking_img1: this.state.img_url_1,
                                            booking_img2: this.state.img_url_2,
                                            booking_img3: this.state.img_url_3,
                                            booking_img4: this.state.img_url_4,
                                        },
                                        taskDataFromConfirmPage: this.state.taskDatanewData,
                                        taskData: this.state.taskDetailsPrev,
                                        loginPath: 'BookingConfirmgback',
                                        BookingPath: "TimeSlotSelectedState",
                                        value: 1
                                    });
                                }}
                            />

                            {/* New Design */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',

                            }}>

                                <div
                                    id="booking"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '20px'
                                    }}>
                                    <div
                                        id="outsidediv"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%'
                                        }}>
                                        <div style={{
                                            // backgroundColor: 'lightgreen',
                                            // width: '50%',
                                            // padding: 10,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // justifyContent: 'space-between'
                                            // marginTop: 35
                                        }}>
                                            <div style={card}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '-20px'
                                                }}>
                                                    <p style={cardHeading}
                                                    >
                                                        Service Details
                                                    </p>
                                                </div>
                                                <p
                                                    id="font"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        fontSize: 18,
                                                        marginBottom: 0
                                                    }}>{this.state.taskDetailsPrev.full_name.service} ({this.state.taskDetailsPrev.full_name.master_category} / {this.state.taskDetailsPrev.full_name.category})</p>
                                                <p
                                                    id="font"
                                                    style={{
                                                        fontSize: 18,
                                                        marginBottom: 0
                                                    }}>Description: {this.state.taskDetailsPrev.description}</p>
                                                <p
                                                    id="font"
                                                    style={{
                                                        fontSize: 18,
                                                        marginBottom: 0
                                                    }}>Booking Type: {this.state.taskDetailsPrev.service_type} | {this.state.taskDetailsPrev.booking_type}</p>
                                                <p
                                                    id="font"
                                                    style={{
                                                        fontSize: 18,
                                                        marginBottom: 0
                                                    }}>Booking Unit: {this.state.taskDetailsPrev.quantity}</p>
                                                <div
                                                    id="font"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                    <p
                                                        id="font"
                                                        style={{
                                                            fontWeight: 'bold',
                                                            fontSize: 18,
                                                        }}>Total Charges: ${roundUpTransaction(this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice)
                                                        }</p>
                                                </div>
                                            </div>

                                        </div>

                                        <div style={{ ...card }}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginBottom: '-20px'
                                            }}>
                                                <p style={cardHeading}>Booking Address</p>

                                                {authToken === 'Guest' || authToken === null ? (
                                                    <button
                                                        onClick={() =>
                                                            this.props.history.push('/user/signin', {
                                                                booking_data: {
                                                                    booking_slot: this.state.selectedTimeSlotLabel,
                                                                    booking_slot_state: this.state.isTimeslotSelected,
                                                                    booking_date: this.state.todaysDate,
                                                                    home_instruction: this.state.home_stay,
                                                                    instructions: this.state.home_instruction,
                                                                    home_stay: this.state.home_aval,
                                                                    refer_code: this.state.refer_code,
                                                                    ref_flag: this.state.ref_flag,
                                                                    booking_img1: this.state.img_url_1,
                                                                    booking_img2: this.state.img_url_2,
                                                                    booking_img3: this.state.img_url_3,
                                                                    booking_img4: this.state.img_url_4
                                                                },
                                                                taskData: this.state.taskDetailsPrev,
                                                                loginPath: 'BookingConfirmAdressSignIn',
                                                                taskDataFromConfirmPage: this.state.taskDatanewData,
                                                                BookingPath: "TimeSlotSelectedState",
                                                                value: 1,
                                                            })
                                                        }

                                                        style={{
                                                            color: 'red',
                                                            fontWeight: '400',
                                                            padding: '5px 20px',
                                                            borderRadius: 50,
                                                            fontSize: 18,
                                                            marginBottom: 25,
                                                            border: '1px solid red',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Add
                                                    </button>
                                                ) : !this.state.addressData ?
                                                    (
                                                        <button
                                                            onClick={() =>
                                                                this.props.history.push({
                                                                    pathname: `/user/address/create`,
                                                                    booking_data: {
                                                                        booking_slot: this.state.selectedTimeSlotLabel,
                                                                        booking_slot_state: this.state.isTimeslotSelected,
                                                                        booking_date: this.state.todaysDate,
                                                                        home_instruction: this.state.home_stay,
                                                                        instructions: this.state.home_instruction,
                                                                        home_stay: this.state.home_aval,
                                                                        refer_code: this.state.refer_code,
                                                                        ref_flag: this.state.ref_flag,
                                                                        booking_img1: this.state.img_url_1,
                                                                        booking_img2: this.state.img_url_2,
                                                                        booking_img3: this.state.img_url_3,
                                                                        booking_img4: this.state.img_url_4
                                                                    },
                                                                    taskData: this.state.taskDetailsPrev,
                                                                    loginPath: 'BookingConfirmAdressAdd',
                                                                    taskDataFromConfirmPage: this.state.taskDatanewData,
                                                                    BookingPath: "TimeSlotSelectedState",
                                                                    value: 1,
                                                                })
                                                            }
                                                            style={{
                                                                textDecoration: 'underline',
                                                                color: '#0078ff',
                                                                cursor: 'pointer',
                                                                fontWeight: '400',
                                                                padding: '5px 20px',
                                                                borderRadius: 50,
                                                                fontSize: 18,
                                                                marginBottom: 25,
                                                                border: '1px solid red',
                                                                textDecoration: 'none',
                                                            }}
                                                        >
                                                            Add
                                                        </button>
                                                    ) :
                                                    (
                                                        <button
                                                            style={{
                                                                textDecoration: 'underline',
                                                                color: '#0078ff',
                                                                cursor: 'pointer',
                                                                fontWeight: '400',
                                                                padding: '5px 20px',
                                                                borderRadius: 50,
                                                                fontSize: 18,
                                                                marginBottom: 25,
                                                                border: '1px solid #0078ff',
                                                                textDecoration: 'none',
                                                            }}
                                                            onClick={() =>
                                                                this.props.history.push({
                                                                    pathname: `/user/address/update/${this.state.addressData.key}`,
                                                                    state: { item: this.state.addressData },
                                                                    booking_data: {
                                                                        booking_slot: this.state.selectedTimeSlotLabel,
                                                                        booking_slot_state: this.state.isTimeslotSelected,
                                                                        booking_date: this.state.todaysDate,
                                                                        home_instruction: this.state.home_stay,
                                                                        instructions: this.state.home_instruction,
                                                                        home_stay: this.state.home_aval,
                                                                        refer_code: this.state.refer_code,
                                                                        ref_flag: this.state.ref_flag,
                                                                        booking_img1: this.state.img_url_1,
                                                                        booking_img2: this.state.img_url_2,
                                                                        booking_img3: this.state.img_url_3,
                                                                        booking_img4: this.state.img_url_4,
                                                                        timevalue: 2
                                                                    },
                                                                    taskData: this.state.taskDetailsPrev,
                                                                    loginPath: 'BookingConfirmAdressLogin',
                                                                    taskDataFromConfirmPage: this.state.taskDatanewData,
                                                                    BookingPath: "TimeSlotSelectedState",
                                                                    value: 1,
                                                                })
                                                            }
                                                        >
                                                            Edit
                                                        </button>
                                                    )
                                                }

                                            </div>
                                            {
                                                !this.state.addressData || Object.keys(this.state.addressData).length === 0 ?
                                                    (
                                                        <div>
                                                            <p style={infoHead}>No Address Found</p>
                                                        </div>
                                                    )
                                                    :
                                                    (
                                                        <div>
                                                            <p
                                                                id="font"
                                                                style={{ ...infoHead, marginBottom: 0 }}>{this.state.addressData.city}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>Address -{this.state.addressData.address_line1}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>State -{this.state.addressData.state}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>Zip -{this.state.addressData.zipcode}</p>
                                                        </div>
                                                    )
                                            }
                                        </div>
                                        <div
                                            id="paymetId"
                                            style={{
                                                // backgroundColor: 'lightcoral',
                                                // width: '50%',
                                                // padding: 10,
                                                // marginTop: -30
                                            }}>
                                            {/* <p>Payment details</p> */}
                                            {/* <p>buttons</p> */}
                                            <div style={card}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '-20px'
                                                }}>
                                                    <p style={cardHeading}>Payment Method</p>

                                                    {
                                                        authToken === 'Guest' || authToken === null
                                                            ?
                                                            <button
                                                                onClick={() => this.props.history.push('/user/signin', {
                                                                    booking_data: {
                                                                        booking_slot: this.state.selectedTimeSlotLabel,
                                                                        booking_slot_state: this.state.isTimeslotSelected,
                                                                        booking_date: this.state.todaysDate,
                                                                        home_instruction: this.state.home_stay,
                                                                        instructions: this.state.home_instruction,
                                                                        home_stay: this.state.home_aval,
                                                                        refer_code: this.state.refer_code,
                                                                        ref_flag: this.state.ref_flag,
                                                                        booking_img1: this.state.img_url_1,
                                                                        booking_img2: this.state.img_url_2,
                                                                        booking_img3: this.state.img_url_3,
                                                                        booking_img4: this.state.img_url_4,
                                                                        bookingPath: this.state.bookingPath,
                                                                        bookingSlotEdit: this.state.bookingSlotEdit,
                                                                        bookingDateEdit: this.state.bookingDateEdit
                                                                    },
                                                                    taskData: this.state.taskDetailsPrev,
                                                                    taskDataFututre: this.state.taskDatanewData,
                                                                    loginPath: 'BookingConfirmPaymentSignIn',
                                                                    taskDataFromConfirmPage: this.state.taskDatanewData,
                                                                    value: 2,
                                                                    futureValue: 2,
                                                                    BookingPath: "TimeSlotSelectedState"
                                                                })}
                                                                style={{
                                                                    color: 'red',
                                                                    fontWeight: '400',
                                                                    padding: '5px 20px',
                                                                    borderRadius: 50,
                                                                    fontSize: 18,
                                                                    marginBottom: 25,
                                                                    border: '1px solid red',
                                                                    textDecoration: 'none',
                                                                    cursor: 'pointer'
                                                                }}>
                                                                Add
                                                            </button>
                                                            :
                                                            this.state.cardListNew.length > 0

                                                                ? (
                                                                    <button
                                                                        // onClick={() => this.props.history.push('/user/profile')}
                                                                        onClick={this.handleAddClick}
                                                                        style={{
                                                                            textDecoration: 'underline',
                                                                            color: '#0078ff',
                                                                            cursor: 'pointer',
                                                                            fontWeight: '400',
                                                                            padding: '5px 20px',
                                                                            borderRadius: 50,
                                                                            fontSize: 18,
                                                                            marginBottom: 25,
                                                                            border: '1px solid #0078ff',
                                                                            textDecoration: 'none',
                                                                        }}>
                                                                        Edit
                                                                    </button>
                                                                )
                                                                :
                                                                (
                                                                    <button
                                                                        style={{
                                                                            textDecoration: 'underline',
                                                                            color: '#0078ff',
                                                                            cursor: 'pointer',
                                                                            fontWeight: '400',
                                                                            padding: '5px 20px',
                                                                            borderRadius: 50,
                                                                            fontSize: 18,
                                                                            marginBottom: 25,
                                                                            border: '1px solid red',
                                                                            textDecoration: 'none',
                                                                        }}
                                                                        onClick={() => this.props.history.push('/user/profile',
                                                                            {
                                                                                booking_data: {
                                                                                    booking_slot: this.state.selectedTimeSlotLabel,
                                                                                    booking_slot_state: this.state.isTimeslotSelected,
                                                                                    booking_date: this.state.todaysDate,
                                                                                    home_instruction: this.state.home_stay,
                                                                                    instructions: this.state.home_instruction,
                                                                                    home_stay: this.state.home_aval,
                                                                                    refer_code: this.state.refer_code,
                                                                                    ref_flag: this.state.ref_flag,
                                                                                    booking_img1: this.state.img_url_1,
                                                                                    booking_img2: this.state.img_url_2,
                                                                                    booking_img3: this.state.img_url_3,
                                                                                    booking_img4: this.state.img_url_4
                                                                                },
                                                                                taskData: this.state.taskDetailsPrev,
                                                                                taskDataFromConfirmPage: this.state.taskDatanewData,
                                                                                loginPath: 'BookingConfirmPaymentLogin',
                                                                                booking_msg: "testing",
                                                                                value: 2,
                                                                                futureValue: 1,
                                                                                BookingPath: "TimeSlotSelectedState"
                                                                            }

                                                                        )}
                                                                    >Add
                                                                    </button>
                                                                )
                                                    }
                                                </div>
                                                {

                                                    this.state.cardListNew.length > 0

                                                        ?
                                                        <div>

                                                            <p
                                                                id="font"
                                                                style={{ ...infoHead, marginBottom: 0 }}>Card - {this.state.cardListNew[0].brand}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>Card Number - **** **** **** {this.state.cardListNew[0].last4}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>Expiry - {this.state.cardListNew[0].exp_month}/{this.state.cardListNew[0].exp_year}</p>
                                                            <p
                                                                id="font"
                                                                style={{
                                                                    fontSize: 18,
                                                                    marginBottom: 0
                                                                }}>Amount Payable - ${roundUpTransaction(this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice) - this.state.booking_discount}
                                                                {this.state.ref_flag && (
                                                                    <span style={{ fontSize: '16px', color: 'blue' }}>
                                                                        &nbsp;(Used referral code - {this.props.userData.referral_code})
                                                                    </span>
                                                                )}</p>
                                                        </div>
                                                        :
                                                        <div>
                                                            <p
                                                                id="font"
                                                                style={infoHead}>No Card Found</p>

                                                        </div>



                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        id="seconddiv"
                                        style={{
                                            display: 'flex',
                                            width: '100%'
                                        }}>

                                        <div
                                            id="calenderId"
                                            style={{
                                                // backgroundColor: 'lightcoral',
                                                // width: '50%',
                                                // padding: 10
                                            }}>
                                            <div style={{
                                                ...card,
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}>
                                                <div style={{
                                                    // marginBottom: 20
                                                }}>
                                                    <p
                                                        id="font1"
                                                        style={{
                                                            fontSize: 20,
                                                            // textAlign: 'center',
                                                            marginBottom: 10
                                                        }}>When do you want the service?</p>
                                                    <div style={{
                                                        display: 'flex',
                                                        // flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        gap: 20,
                                                        alignItems: 'center',
                                                        marginTop: 10
                                                    }}>
                                                        <div
                                                            id="topbtnId"
                                                            onClick={() => this.handleServiceType(0)}
                                                            style={{
                                                                backgroundColor: this.state.todayServiceActive ? '#0078ff' : 'white',
                                                                display: 'flex',
                                                                // flexDirection: 'column',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '2px 20px',
                                                                // marginRight: 20,
                                                                boxShadow: "2px 1px 5px #ddd",
                                                                borderRadius: 10,
                                                                width: '40%',
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <span style={{ color: this.state.todayServiceActive ? 'white' : '#0078ff', }}>
                                                                <AccessTime style={{ fontSize: 40 }} />
                                                            </span>
                                                            <div style={{
                                                                textAlign: 'center'
                                                            }}>
                                                                <p style={{
                                                                    fontSize: 20,
                                                                    color: this.state.todayServiceActive ? 'white' : '#0078ff',
                                                                    // marginTop: 10,
                                                                    marginBottom: 0
                                                                }}>Today</p>
                                                                <p style={{
                                                                    fontSize: 20,
                                                                    marginBottom: 0,
                                                                    color: this.state.todayServiceActive ? 'white' : '#0078ff'
                                                                }}>${this.state.taskDetailsPrev.rush_hr_price}</p>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id="topbtnId"
                                                            onClick={() => this.handleServiceType(1)}
                                                            style={{
                                                                backgroundColor: this.state.futureServiceActive ? '#0078ff' : 'white',
                                                                display: 'flex',
                                                                // flexDirection: 'column',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '2px 20px',
                                                                // marginRight: 20,
                                                                boxShadow: "2px 1px 5px #ddd",
                                                                borderRadius: 10,
                                                                width: '40%',
                                                                // marginTop: 35
                                                            }}
                                                        >
                                                            <span style={{}}>
                                                                <CalendarTodayTwoTone style={{
                                                                    fontSize: 40,
                                                                    color: this.state.futureServiceActive ? 'white' : '#0078ff'
                                                                }} />
                                                            </span>
                                                            <div style={{
                                                                textAlign: 'center',
                                                                cursor: "pointer"
                                                            }}>
                                                                <p style={{
                                                                    fontSize: 20,
                                                                    color: this.state.futureServiceActive ? 'white' : '#0078ff',
                                                                    // marginTop: 10,
                                                                    marginBottom: 0
                                                                }}>Future</p>
                                                                <p style={{
                                                                    fontSize: 20,
                                                                    marginBottom: 0,
                                                                    color: this.state.futureServiceActive ? 'white' : '#0078ff'
                                                                }}>${this.state.taskDetailsPrev.price}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{
                                                    // margin: '20px'
                                                }}>
                                                    <p
                                                        id="font1"
                                                        style={{
                                                            fontSize: 20,
                                                            marginTop: 25,
                                                            // textAlign: 'center'
                                                        }}>Select a Date & Time</p>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        // boxShadow: "2px 1px 5px #ddd",
                                                        marginTop: 10
                                                    }}>
                                                        <Calendar
                                                            style={{ height: "100vh", width: '50%', color: "red", background: "#fff" }}
                                                            onClickDay={(value) => this.state.whichServiceType === 1 && this.onDateSelected(value)}
                                                            minDate={new Date()}
                                                            maxDate={this.state.whichServiceType === 1 ? this.addDays(new Date, 60) : new Date()}
                                                            defaultValue={this.state.bookingPath == 'edit' ? this.state.bookingDateEdit : this.state.todaysDate}
                                                            // tileDisabled={({date}) => date.getDate() === new Date()}
                                                            tileDisabled={({ date }) => this.state.whichServiceType === 1 ? date.getDate() === date1 : null}
                                                        />
                                                        {
                                                            this.state.whichServiceType === 1
                                                                ? this.renderFutureTimeslots()
                                                                : this.renderTodayTimeslots()
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="thirddiv"
                                style={{
                                    display: 'flex',
                                    width: '100%'
                                }}>
                                <div>
                                    <div
                                        id="instructionid"
                                        style={{
                                            // backgroundColor: 'lightgreen',
                                            width: '100%',
                                            // padding: 10,
                                            // marginTop: -10
                                        }}>
                                        <div style={card}>
                                            <div
                                                id="add_instructions"
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                }}>
                                                <div
                                                    id="will_be_home"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'baseline'
                                                    }}>
                                                    <p
                                                        id="font1"
                                                        style={{ fontSize: 20, }}>Will you be Home?</p>
                                                    <div

                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            // justifyContent: 'center',
                                                        }}>
                                                        <Radio
                                                            className="checked-radio"
                                                            checked={
                                                                this.state.home_aval == 1
                                                            }
                                                            onChange={event => this.handleRadioChange(event)}
                                                            // onChange={this.handlePaymentOption}
                                                            value="1"
                                                            color="primary"
                                                        //  style={{ backgroundColor: this.state.color }}
                                                        /><p style={{ textAlign: 'center', marginTop: 10 }}>Yes</p>
                                                        <Radio
                                                            className="checked-radio"
                                                            checked={
                                                                this.state.home_aval == 2
                                                            }
                                                            onChange={event => this.handleRadioChange(event)}
                                                            // onChange={this.handlePaymentOption}
                                                            value="2"
                                                            color="primary"
                                                        //  style={{ backgroundColor: this.state.color }}
                                                        /><p style={{ textAlign: 'center', marginTop: 10 }}>No</p>
                                                    </div>
                                                </div>
                                                {
                                                    this.state.home_aval == 2 &&
                                                    <textarea
                                                        // id="required"
                                                        // className="border-0 form-control chat-textarea"
                                                        // onKeyUp={this._handleKeyPress.bind(this)}
                                                        onChange={(e) => {
                                                            this.setState({ home_stay: e.target.value });

                                                        }}
                                                        value={this.state.home_stay}
                                                        placeholder="Please leave a message if you will not be home."
                                                        style={{
                                                            height: '7vh',
                                                            borderRadius: '10px',
                                                            marginBottom: 20
                                                        }}
                                                    />
                                                }
                                            </div>
                                            <div>
                                                <p
                                                    id="font1"
                                                    style={{ fontSize: 20, }}>Add notes / instructions</p>
                                                <textarea
                                                    // id="required"
                                                    // className="border-0 form-control chat-textarea"
                                                    // onKeyUp={this._handleKeyPress.bind(this)}
                                                    onChange={(e) => { this.addInstruction(e) }}
                                                    value={this.state.home_instruction}
                                                    placeholder="Add instructions"
                                                    style={{
                                                        height: '7vh',
                                                        borderRadius: '10px',
                                                        marginBottom: 20
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <p
                                                    id="font1"
                                                    style={{ fontSize: 20, }}>Add Photos</p>
                                                <p style={{ color: 'red' }}>*Allowed file size is 10MB and supports only JPEG/PNG</p>
                                                <div
                                                    id="add_photo"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-evenly',
                                                        alignItems: 'center',
                                                        border: '1px solid #eee',
                                                        borderRadius: '10px',
                                                        overflow: 'auto',
                                                        overflowY: 'hidden',
                                                        padding: '2px 0px 2px 0px',
                                                        cursor: "pointer"
                                                    }}>
                                                    {
                                                        this.state.img_url_1
                                                            ?
                                                            <img
                                                                //  src={this.state.img_url_1} 
                                                                src={this.state.profileImagebase64Data1 ?
                                                                    `data:image;base64,${this.state.profileImagebase64Data1}` : this.state.img_url_1}
                                                                style={{ height: '5rem', width: '5rem', borderRadius: 10 }} />
                                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                {/* <Box > <Add fontSize='large' /></Box> */}
                                                                <AdditionImagePicker
                                                                    handleDrop={this.handleImage1Drop}
                                                                    handleDropRejected={this.handleImage1DropRejected}
                                                                    userData={this.props.userData}
                                                                    state={this.state}
                                                                    imageUploaded={this.state.imageUploaded}
                                                                    // front_imageId={this.state.front_imageId}
                                                                    noOfUpload={1}
                                                                />
                                                                <Typography style={{ color: '#717175', textAlign: 'center' }}>
                                                                    Add Photo
                                                                </Typography>
                                                            </Box>
                                                    }
                                                    {
                                                        this.state.img_url_2
                                                            ?
                                                            <img
                                                                //  src={this.state.img_url_1} 
                                                                src={this.state.profileImagebase64Data2 ?
                                                                    `data:image;base64,${this.state.profileImagebase64Data2}` : this.state.img_url_2}
                                                                style={{ height: '5rem', width: '5rem', borderRadius: 10 }} />
                                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                {/* <Box > <Add fontSize='large' /></Box> */}
                                                                <AdditionImagePicker
                                                                    handleDrop={this.handleImage2Drop}
                                                                    handleDropRejected={this.handleImage1DropRejected}
                                                                    userData={this.props.userData}
                                                                    state={this.state}
                                                                    imageUploaded={this.state.imageUploaded}
                                                                    // front_imageId={this.state.front_imageId}
                                                                    noOfUpload={1}
                                                                />
                                                                <Typography style={{ color: '#717175', textAlign: 'center' }}>
                                                                    Add Photo
                                                                </Typography>
                                                            </Box>
                                                    }
                                                    {
                                                        this.state.img_url_3
                                                            ?
                                                            <img
                                                                //  src={this.state.img_url_1} 
                                                                src={this.state.profileImagebase64Data3 ?
                                                                    `data:image;base64,${this.state.profileImagebase64Data3}` : this.state.img_url_3}
                                                                style={{ height: '5rem', width: '5rem', borderRadius: 10 }} />
                                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                {/* <Box > <Add fontSize='large' /></Box> */}
                                                                <AdditionImagePicker
                                                                    handleDrop={this.handleImage3Drop}
                                                                    handleDropRejected={this.handleImage1DropRejected}
                                                                    userData={this.props.userData}
                                                                    state={this.state}
                                                                    imageUploaded={this.state.imageUploaded}
                                                                    // front_imageId={this.state.front_imageId}
                                                                    noOfUpload={1}
                                                                />
                                                                <Typography style={{ color: '#717175', textAlign: 'center' }}>
                                                                    Add Photo
                                                                </Typography>
                                                            </Box>
                                                    }
                                                    {
                                                        this.state.img_url_4
                                                            ?
                                                            <img
                                                                //  src={this.state.img_url_1} 
                                                                src={this.state.profileImagebase64Data4 ?
                                                                    `data:image;base64,${this.state.profileImagebase64Data4}` : this.state.img_url_4}
                                                                style={{ height: '5rem', width: '5rem', borderRadius: 10 }} />
                                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                                                {/* <Box > <Add fontSize='large' /></Box> */}
                                                                <AdditionImagePicker
                                                                    handleDrop={this.handleImage4Drop}
                                                                    handleDropRejected={this.handleImage1DropRejected}
                                                                    userData={this.props.userData}
                                                                    state={this.state}
                                                                    imageUploaded={this.state.imageUploaded}
                                                                    // front_imageId={this.state.front_imageId}
                                                                    noOfUpload={1}
                                                                />
                                                                <Typography style={{ color: '#717175', textAlign: 'center' }}>
                                                                    Add Photo
                                                                </Typography>
                                                            </Box>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div>
                                            {
                                                this.state.bookingAgreeError
                                                    ? <p style={{ color: 'red', fontSize: 17, marginLeft: 47 }}>Please accept Terms and Condition</p>
                                                    : null
                                            }
                                            <div
                                                id="margin_signup"
                                                className="term-radio-test"
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    // justifyContent: 'center',
                                                    marginTop: 45
                                                }}>
                                                <Radio
                                                    className="checked-radio"
                                                    checked={
                                                        this.state.booking_agree == 1
                                                    }
                                                    onChange={event => this.handleRadioChangeForBooking(event)}
                                                    // onChange={this.handlePaymentOption}
                                                    value="1"
                                                    color="primary"
                                                    style={{}}
                                                /><p

                                                    style={{
                                                        fontSize: 18
                                                    }}>I understand that I am purchasing a service subject to ezPro's{" "}
                                                    <span
                                                        onClick={() => this.setState({ showTermOfUseAlert: true })}
                                                        style={{
                                                            color: '#0078ff',
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer'
                                                        }}>Term of use
                                                    </span>
                                                    {" "}and{" "}
                                                    <span
                                                        onClick={() => this.setState({ showCancellationPolicyAlert: true })}
                                                        style={{
                                                            color: '#0078ff',
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer'
                                                        }}>Cancellation Policy
                                                    </span>
                                                    {" "}and my payment method will be charged before the service.</p>
                                            </div>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            marginTop: 20,
                                            marginRight: 30
                                        }}>
                                            <p
                                                onClick={this.handleCancelNow}
                                                style={{
                                                    backgroundColor: 'red',
                                                    padding: '7px 20px',
                                                    color: '#fff',
                                                    borderRadius: 5,
                                                    fontSize: 17,
                                                    width: 150,
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    cursor: 'pointer'
                                                }}>Cancel</p>


                                            <div>
                                                {
                                                    <p onClick={this.handleBookNow}
                                                    className="booking-btn-test"
                                                        style={{
                                                            backgroundColor: '#0078ff',
                                                            padding: '7px 20px',
                                                            color: '#fff',
                                                            borderRadius: 5,

                                                            fontSize: 17,
                                                            width: 150,
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            marginLeft: 20,
                                                            cursor: 'pointer',
                                                        }}>
                                                        Book Now
                                                    </p>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BookingConfirmAlert
                    open={this.state.showAlert}
                    title=""
                    close={() => this.setState({ showAlert: false })}
                    handleYes={this.onBookNowStart}
                    handleNo={() => this.setState({ showAlert: false, loading: false })}
                />
                <TermsOfUseAlert
                    open={this.state.showTermOfUseAlert}
                    title=""
                    content="By accepting this you agree with the adjusted pricing shown above. You will be automatially charged the difference between the orginal amount and the new amount you are accepting. Do you want to continue?"
                    close={() => this.setState({ showTermOfUseAlert: false })}
                    handleYes={() => this.setState({ showTermOfUseAlert: false })}
                    handleNo={() => this.setState({ showTermOfUseAlert: false })}
                />
                <CancellationPolicyAlert
                    open={this.state.showCancellationPolicyAlert}
                    title=""
                    content=""
                    close={() => this.setState({ showCancellationPolicyAlert: false })}
                    handleYes={() => this.setState({ showCancellationPolicyAlert: false })}
                    handleNo={() => this.setState({ showCancellationPolicyAlert: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader,
    };
};
const composedComponent = compose(connect(mapStateToProps, actions));
// export default composedProfile(withRouter(ConfirmBookingScreenNewLayout));

const ColoredDateCellWrapper = ({ children }) =>
    React.cloneElement(React.Children.only(children), {
        style: {
            backgroundColor: "lightblue",
        },
    });

export default composedComponent(ConfirmBookingScreenNewLayout);



// WEBPACK FOOTER //
// ./src/views/User/ConfirmBookingScreenNewLayout.jsx